import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgHamburgerMenu = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.60001 3.20001C1.30546 3.20001 1.06668 3.4388 1.06668 3.73335C1.06668 4.02789 1.30546 4.26668 1.60001 4.26668H14.4C14.6945 4.26668 14.9333 4.02789 14.9333 3.73335C14.9333 3.4388 14.6945 3.20001 14.4 3.20001H1.60001ZM1.06668 8.00001C1.06668 7.70546 1.30546 7.46668 1.60001 7.46668H14.4C14.6945 7.46668 14.9333 7.70546 14.9333 8.00001C14.9333 8.29456 14.6945 8.53335 14.4 8.53335H1.60001C1.30546 8.53335 1.06668 8.29456 1.06668 8.00001ZM1.06668 12.2667C1.06668 11.9722 1.30546 11.7333 1.60001 11.7333H14.4C14.6945 11.7333 14.9333 11.9722 14.9333 12.2667C14.9333 12.5612 14.6945 12.8 14.4 12.8H1.60001C1.30546 12.8 1.06668 12.5612 1.06668 12.2667Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgHamburgerMenu)
const IconSvgHamburgerMenu = createIcon(ForwardRef, 'SvgHamburgerMenu')
export default IconSvgHamburgerMenu
